(() => {
 if(window.fflChristmasListingGuard)return;
 window.fflChristmasListingGuard=true;
 const setup=()=>{
  const c=document.querySelector('#FFLCustomizer');
  const config=document.querySelector('[data-ffl-christmas-config]');
  const form=document.querySelector('product-form form[action*="/cart/add"]');
  if(!c||!form||!config)return;
  // File uploads require the JSON Cart API endpoint for the fee follow-up.
  if(window.routes)window.routes.cart_add_url=(window.Shopify?.routes?.root||'/')+'cart/add.js';
  c.querySelectorAll('input,select,textarea').forEach(f=>f.setAttribute('form',form.getAttribute('id')));
  for(const [name,max] of [['Personalized name',24],['Personalized message',48]]){
   const f=c.querySelector('[name="properties['+name+']"]');if(f)f.maxLength=max;
  }
  const year=c.querySelector('[name="properties[Personalized year]"]');
  if(year){year.maxLength=4;year.pattern='[0-9]{4}';year.inputMode='numeric';year.title='Enter a four-digit year, or leave blank.';}
  if(!c.querySelector('[name="properties[Scene and subject confirmation]"]')){
   const label=document.createElement('label');label.style.cssText='display:flex;gap:12px;align-items:flex-start;margin:20px 0;line-height:1.6';
   const check=document.createElement('input');check.type='checkbox';check.required=true;check.name='properties[Scene and subject confirmation]';check.value=config.dataset.scope+'; illustrated Christmas scene';check.setAttribute('form',form.getAttribute('id'));
   label.append(check,document.createTextNode('I confirm this design is for '+config.dataset.scope+', and understand that the Christmas setting and clothing are illustrated from my photo references.'));
   c.querySelector('[data-customizer-step]').append(label);
   const hidden=document.createElement('input');hidden.type='hidden';hidden.name='properties[_Design ID]';hidden.value=config.dataset.design;hidden.setAttribute('form',form.getAttribute('id'));c.append(hidden);
  }
 };
 setup();document.addEventListener('shopify:section:load',setup);
 document.addEventListener('submit',event=>{
  const form=event.target;if(!(form instanceof HTMLFormElement)||!form.matches('product-form form[action*="/cart/add"]'))return;
  setup();const c=document.querySelector('#FFLCustomizer');
  const fields=c?[...c.querySelectorAll('input,select,textarea')]:[];
  const invalid=fields.find(f=>!f.disabled&&!f.checkValidity());
  if(!c||invalid){event.preventDefault();event.stopImmediatePropagation();if(invalid){const d=invalid.closest('details');if(d)d.open=true;invalid.scrollIntoView({behavior:'smooth',block:'center'});invalid.focus({preventScroll:true});invalid.reportValidity();}}
 },true);
})();

